import {useEffect, useState} from "react";

export default function useLanguagePairs(filters) {
    const [loading, setLoading] = useState(true);
    const [languagePairs, setLanguagePairs] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();
        let isMounted = true;

        (async () => {
            setLoading(true);

            try {
                const queryParams = new URLSearchParams();

                for (const prop in filters) {
                    queryParams.append(prop, filters[prop]);
                }

                const response = await fetch(process.env.REACT_APP_ENDPOINT + '/languagePairs?' + queryParams.toString(), {
                    method: "GET",
                    credentials: "include",
                    signal: abortController.signal
                });
                if (response.status === 200) {
                    const {languagePairs} = await response.json();
                    isMounted && setLanguagePairs(languagePairs);
                }
                else {
                    throw new Error("Wrong status code.");
                }
            }
            catch (e) {
                console.error(e);
            }
            finally {
                isMounted && setLoading(false);
            }
        })();

        return () => {
            isMounted = false;
            abortController.abort();
        }
    }, []);

    return {
        loading,
        languagePairs
    };
}